import { httpCreate } from './http';

const http = httpCreate('/srv/gather-watch-user/');

export const gatherWatchUser = {
	// 获取观看列表
	getWatchList(albumId, params) {
		return http.get(`/watchList/${albumId}`, { params });
	},
};
